import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';

class NotFound404 extends React.Component {

    render() {

        return (
            <div className="panel panel-default" id="panel-404">
                <div className="panel-heading">
                    <h2 className="panel-title"><FormattedMessage id="LABEL_NOT_FOUND_404"/></h2>
                </div>
                <div className="panel-body">
                <p><FormattedMessage id="TEXT_NOT_FOUND_404"/></p>
                <Link to="/dashboard" role="button" className="btn btn-primary"><FormattedMessage id="LABEL_BACK_TO_HOMEPAGE"/></Link>
                </div>
            </div>
        )
    }
}

export default NotFound404;


// WEBPACK FOOTER //
// ./src/js/components/NotFound404.react.jsx